import { Component, inject, signal } from '@angular/core';
import { FormService } from 'src/app/services/form/form.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PayeeDropzoneDirective } from '../../../../../shared/payee-dropzone/payee-dropzone.directive';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-ocr-uploader',
  templateUrl: './invoice-ocr-uploader.component.html',
  styleUrls: ['./invoice-ocr-uploader.component.scss'],
  imports: [
    MatProgressSpinner,
    PayeeDropzoneDirective,
    MatIcon,
    TranslateModule,
  ],
})
export class InvoiceOcrUploaderComponent {
  private formService = inject(FormService);

  readonly loading = signal(false);

  async fileDropped(files: FileList | null): Promise<void> {
    const list = files ? Array.from(files) : [];
    if (list.length === 0) {
      return;
    }

    this.loading.set(true);
    try {
      await this.formService.parseInvoiceFiles(list);
    } finally {
      this.loading.set(false);
    }
  }
}
